"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Pagination_1 = __importDefault(require("@components/Pagination"));
var table_1 = require("@utils/table");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var searchDocumentV2_1 = require("@/react-app/common/services/searchDocumentV2");
function Count(_a) {
    var _b;
    var transformedData = _a.transformedData, countRequestQueryOption = _a.countRequestQueryOption, filterId = _a.filterId, isMainQueryLoading = _a.isMainQueryLoading;
    // Not the best approach to handle the filterId, but it works for now.
    // All fullText.queryString filters will be replated by the filters object
    var currentFilterIdQuery = "(metadata.automaticResults.filters.id: ".concat(filterId, ") AND");
    var queryStringWithoutFilterId = ((_b = countRequestQueryOption.fullText) === null || _b === void 0 ? void 0 : _b.queryString)
        ? countRequestQueryOption.fullText.queryString.replace(currentFilterIdQuery, '').trim()
        : '';
    var countRequestQueryWithoutFilterId = __assign(__assign({}, countRequestQueryOption), { fullText: __assign(__assign({}, countRequestQueryOption.fullText), { queryString: queryStringWithoutFilterId }) });
    var _c = (0, searchDocumentV2_1.useSearchDocumentsCountQuery)(countRequestQueryWithoutFilterId), countData = _c.data, isLoading = _c.isLoading, isFetching = _c.isFetching;
    var total = transformedData.total;
    var hasPercentage = (countData === null || countData === void 0 ? void 0 : countData.count) && !!countData.count; // "count" exists and is non-zero
    var _d = __read((0, react_1.useState)(null), 2), percentage = _d[0], setPercentage = _d[1];
    (0, react_1.useEffect)(function () {
        if (!isLoading && !isFetching && !isMainQueryLoading) {
            var percentageCount = hasPercentage && (total / countData.count) * 100;
            setPercentage(typeof percentageCount === 'number' ? (0, table_1.formatPercentage)(percentageCount) : null);
        }
    }, [countData, total, hasPercentage, isLoading, isFetching, isMainQueryLoading]);
    return (react_1.default.createElement(react_1.default.Fragment, null, total > 0 && filterId && hasPercentage && percentage && (react_1.default.createElement("span", null,
        "(",
        react_1.default.createElement("strong", null, percentage),
        "\u00A0",
        react_1.default.createElement(react_i18next_1.Trans, { i18nKey: "AUTOMATION.DECISION_RULES.RULE_VIEW.OF_ALL_ITEMS" }),
        ")"))));
}
function TopBarPagination(_a) {
    var _b;
    var countRequestQueryOption = _a.countRequestQueryOption, className = _a.className, paginate = _a.paginate, filterId = _a.filterId, refreshTimestamp = _a.refreshTimestamp, transformedData = _a.transformedData, isLoading = _a.isLoading;
    var total = transformedData.total, currentItemOffsetInDecimal = transformedData.currentItemOffsetInDecimal, items = transformedData.items, currentPage = transformedData.currentPage, isNextDisabled = transformedData.isNextDisabled, isPreviousDisabled = transformedData.isPreviousDisabled;
    var range = (0, table_1.getRange)(currentItemOffsetInDecimal, items === null || items === void 0 ? void 0 : items.length);
    var formattedTotal = (0, table_1.formatTotal)(total);
    var t = (0, react_i18next_1.useTranslation)('itemLog').t;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Pagination_1.default, { className: className, loading: isLoading, paginate: paginate, currentPage: currentPage, isNextDisabled: isNextDisabled, isPreviousDisabled: isPreviousDisabled }),
        react_1.default.createElement("i", { className: "implioicons-re-do eva-items-log-refresh-icon ".concat(isLoading ? 'disabled' : ''), onClick: refreshTimestamp, title: (_b = t('itemLog:REFRESH_BUTTON_TOOLTIP')) !== null && _b !== void 0 ? _b : '' }),
        react_1.default.createElement("div", { className: "count" },
            total >= 0 && (react_1.default.createElement("span", null,
                (total || 0) > 0 && (react_1.default.createElement(react_i18next_1.Trans
                // when total is 1 we show item SHOW_RESULT_one
                // when total is more than 1 we show items SHOW_RESULT_other
                , { 
                    // when total is 1 we show item SHOW_RESULT_one
                    // when total is more than 1 we show items SHOW_RESULT_other
                    i18nKey: "itemLog:SHOW_RESULT", count: total || 0, values: { range: range, formattedTotal: formattedTotal }, components: {
                        bold: react_1.default.createElement("strong", null),
                    } })),
                (total || 0) === 0 && t('itemLog:SHOW_RESULT_NO_ITEM'),
                "\u00A0")),
            filterId && (react_1.default.createElement(Count, { transformedData: transformedData, countRequestQueryOption: countRequestQueryOption, filterId: filterId, isMainQueryLoading: isLoading })))));
}
exports.default = TopBarPagination;
